import loginDataReducer from './loginData' 
import apiDataReducer from './apiData'  
import apiLoaderReducer from './apiLoader' 
import assignmentData from './assignmentData' 
import socketData from './socketData' 
import messageData from './messageData' 
import patientData from './patientData' 
import videoCallData from './videoCallData' 
import chatUserIdData from './chatUserIdData' 
import { combineReducers } from "redux"
 


const allReducers = combineReducers({  
    loginData: loginDataReducer,  
    apiData: apiDataReducer,
    apiLoader: apiLoaderReducer,    
    assignmentData: assignmentData,    
    socketData: socketData,    
    patientData: patientData,    
    videoCallData: videoCallData,    
    messageData: messageData,    
    chatUserIdData: chatUserIdData,    
})

export default allReducers;